export default "__VITE_ASSET__C0g6BPVw__"